module.exports = __webpack_public_path__ + "static/media/compare-button.7ffbc39d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/compare-button.svg
// module id = 316
// module chunks = 0